<template>
  <v-toolbar flat>
    <div
      style="width: 150px">
      <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2">
      </ejercicio-picker>
    </div>
    <div
      style="width: 300px">
      <custom-select
        v-model="filtros.tipos"
        label="Tipo"
        item-value="id"
        item-text="descripcion"
        multiple
        clearable
        :items="tiposDeObra">
      </custom-select>
    </div>
    <div style="width: 350px" class="mr-2">
      <custom-text-field
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <filtros
      :contratos="listaContratos"
      :filtros="filtros">
    </filtros>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
import Filtros from './Filtros.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'ToolBarEstimaciones',
  props: {
    listaContratos: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomSelect,
    EjercicioPicker,
    Filtros,
    CustomTextField,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
  },
  computed: {
    tiposDeObra() {
      const tiposDeObraFiltrados = this.listaContratos
        .filter(({ obra }) => obra !== null)
        .map(({ obra }) => obra.obra.tipo);

      return this.$removerDumplicadosArrayObj(tiposDeObraFiltrados, 'id')
        .sort((a, b) => (`${a.descripcion}`).localeCompare(b.descripcion));
    },
  },
};
</script>

<style lang="scss">
</style>
